module.exports = __webpack_public_path__ + "static/media/xy.508ba06e.png";